/* eslint-disable */
import React from 'react';
import cx from 'classnames';
import './Button.scss';
import { Link } from 'gatsby';
import Loader from './Loader';

const Button = ({
  type,
  variant = 'default',
  as,
  to,
  onClick,
  children,
  disabled,
  $fullWidth,
  className,
  isNonGatsbyButton = false,
  isLoading = false,
}) => {
  const handleClick = () => {
    if (onClick && !isLoading) {
      onClick();
    }
  };

  return isNonGatsbyButton ? (
    <button
      type={type || 'button'}
      onClick={() => handleClick()}
      disabled={disabled}
      className={cx({
        [`button ${className}`]: true,
        'button--secondary': variant === 'secondary',
        'button--third': variant === 'third',
        'button--secondary-white': variant === 'secondaryWhite',
        'button--full-width': $fullWidth,
        'button--disabled': disabled,
      })}
    >
      <p
        className={cx({
          'button__text--loading': isLoading,
        })}
      >
        {children}
      </p>
      {isLoading && <Loader />}
    </button>
  ) : (
    <Link
      type={type}
      as={as}
      to={to}
      variant={variant}
      onClick={onClick}
      $fullWidth={$fullWidth}
      disabled={disabled}
      isNonGatsbyButton={isNonGatsbyButton}
      className={cx({
        [`button ${className}`]: true,
        'button--secondary': variant === 'secondary' && !disabled,
        'button--third': variant === 'third' && !disabled,
        'button--secondary-white': variant === 'secondaryWhite' && !disabled,
        'button--full-width': $fullWidth,
        'button--disabled': disabled,
      })}
    >
      {children}
    </Link>
  );
};

export default Button;
